import type { SVGProps } from "react";

const Primary = (props: SVGProps<SVGSVGElement>) => (
  <svg width="220" height="160" viewBox="0 0 220 160" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="110" cy="80" r="80" fill="url(#paint0_linear_1052_23221)" />
    <circle cx="26" cy="20" r="8" fill="white" />
    <circle cx="198" cy="126" r="6" fill="white" />
    <circle cx="25" cy="138" r="10" fill="white" />
    <circle cx="210" cy="46" r="10" fill="white" />
    <circle cx="191" cy="11" r="7" fill="white" />
    <g filter="url(#filter0_dd_1052_23221)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.486 16C96.7495 16 81.9448 24.2701 72.9354 36.9466C69.9934 36.2528 66.9253 35.8857 63.7714 35.8857C41.8063 35.8857 24 53.692 24 75.6571C24 97.6223 41.8063 115.429 63.7714 115.429H163.2C182.42 115.429 198 99.8481 198 80.6286C198 61.4091 182.42 45.8286 163.2 45.8286C161.835 45.8286 160.488 45.9072 159.164 46.0601C151.546 28.3784 133.961 16 113.486 16Z"
        fill="#FFFBFF"
      />
      <circle cx="63.7714" cy="75.6572" r="39.7714" fill="url(#paint1_linear_1052_23221)" />
      <circle cx="113.486" cy="65.7143" r="49.7143" fill="url(#paint2_linear_1052_23221)" />
      <circle cx="163.2" cy="80.6286" r="34.8" fill="url(#paint3_linear_1052_23221)" />
    </g>
    <defs>
      <filter
        id="filter0_dd_1052_23221"
        x="4"
        y="16"
        width="214"
        height="139.429"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1052_23221" />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1052_23221" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1052_23221" />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_1052_23221" result="effect2_dropShadow_1052_23221" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1052_23221" result="shape" />
      </filter>
      <filter
        id="filter1_b_1052_23221"
        x="74"
        y="76"
        width="72"
        height="72"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1052_23221" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1052_23221" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_1052_23221" x1="110" y1="0" x2="110" y2="160" gradientUnits="userSpaceOnUse">
        <stop stopColor="#EAE6FF" />
        <stop offset="1" stopColor="#D6D3E7" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1052_23221"
        x1="33.2326"
        y1="49.3796"
        x2="103.543"
        y2="115.429"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E9D7FE" />
        <stop offset="0.350715" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1052_23221"
        x1="75.3122"
        y1="32.8673"
        x2="163.2"
        y2="115.428"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E9D7FE" />
        <stop offset="0.350715" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1052_23221"
        x1="136.479"
        y1="57.6357"
        x2="198"
        y2="115.429"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E9D7FE" />
        <stop offset="0.350715" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

const Gray = (props: SVGProps<SVGSVGElement>) => (
  <svg width="220" height="160" viewBox="0 0 220 160" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="110" cy="80" r="80" fill="url(#paint0_linear_1052_23237)" />
    <circle cx="26" cy="20" r="8" fill="white" />
    <circle cx="198" cy="126" r="6" fill="white" />
    <circle cx="25" cy="138" r="10" fill="white" />
    <circle cx="210" cy="46" r="10" fill="white" />
    <circle cx="191" cy="11" r="7" fill="white" />
    <g filter="url(#filter0_dd_1052_23237)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.486 16C96.7495 16 81.9448 24.2701 72.9354 36.9466C69.9934 36.2528 66.9253 35.8857 63.7714 35.8857C41.8063 35.8857 24 53.692 24 75.6571C24 97.6223 41.8063 115.429 63.7714 115.429H163.2C182.42 115.429 198 99.8481 198 80.6286C198 61.4091 182.42 45.8286 163.2 45.8286C161.835 45.8286 160.488 45.9072 159.164 46.0601C151.546 28.3784 133.961 16 113.486 16Z"
        fill="#F0F1F3"
      />
      <circle cx="63.7714" cy="75.6571" r="39.7714" fill="url(#paint1_linear_1052_23237)" />
      <circle cx="113.486" cy="65.7143" r="49.7143" fill="url(#paint2_linear_1052_23237)" />
      <circle cx="163.2" cy="80.6286" r="34.8" fill="url(#paint3_linear_1052_23237)" />
    </g>
    <defs>
      <filter
        id="filter0_dd_1052_23237"
        x="4"
        y="16"
        width="214"
        height="139.429"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1052_23237" />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1052_23237" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1052_23237" />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_1052_23237" result="effect2_dropShadow_1052_23237" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1052_23237" result="shape" />
      </filter>
      <filter
        id="filter1_b_1052_23237"
        x="74"
        y="76"
        width="72"
        height="72"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1052_23237" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1052_23237" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_1052_23237" x1="110" y1="0" x2="110" y2="160" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F3EDFA" />
        <stop offset="1" stopColor="#EBEAED" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1052_23237"
        x1="33.2326"
        y1="49.3796"
        x2="103.543"
        y2="115.429"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D0D5DD" />
        <stop offset="0.350715" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1052_23237"
        x1="75.3122"
        y1="32.8673"
        x2="163.2"
        y2="115.428"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D0D5DD" />
        <stop offset="0.350715" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1052_23237"
        x1="136.479"
        y1="57.6357"
        x2="198"
        y2="115.429"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D0D5DD" />
        <stop offset="0.350715" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const IllustrationCloud = {
  Primary,
  Gray,
};
